import { height } from "@mui/system";
import React from "react";
import error from '../../assets/error.svg'


const ErrorHandler = () => {
    return(
        <>
        <div className="align-content-center align-items-center flex flex-column justify-content-center m-5">
            <h1 className="font-weight-700">Oops</h1>
            <h2 className="font-thin-Table">Something went wrong</h2>
            <h3 className="font-thin">Error 404 Page not found</h3>
            <img src={error} style={{
                width:"40%",
                height:"40%"
            }}></img>
        </div>
        </>
    )

}
export default ErrorHandler